// src/components/FloatingButton.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FloatingButton.css'; // for styling

const FloatingButton = ({ onClick }) => {
    const navigate = useNavigate();
    // Client-side navigation to Contact unless a custom handler is passed
    const handleClick = onClick || (() => navigate('/contact'));

    return (
        <button className="floating-button" onClick={handleClick} title="Contact Us" aria-label="Contact us">
            <span aria-hidden="true">🔗</span>
        </button>
    );
};

export default FloatingButton;
